import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { CSVLink } from 'react-csv';
import { PageHeader } from 'ui/pageHeader';
import { Export24 } from 'ui/icons/aurora';
import { PrimaryButton } from 'ui/button';
import { Table } from 'ui/table';
import { TableRows } from 'ui/tableRows';
import { Skeleton } from 'ui/skeleton';
import { TableHeader } from 'ui/tableHeader';
import * as actions from '../actions';
import { getDnsSetup, selectDnsSetupEntriesForCSV } from '../selectors';
import { COLUMNS, HEADERS } from '../constants';

export const DnsSetup = () => {
  const dispatch = useDispatch();
  const { entries, targetDomain, isLoading } = useSelector(getDnsSetup);
  const csvEntries = useSelector(selectDnsSetupEntriesForCSV);

  useEffect(() => {
    dispatch(actions.fetchDnsSetupRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        pageSubSection="Only applies to customers using Amazon SES"
        pageActions={
          <CSVLink
            data={csvEntries}
            headers={HEADERS}
            filename={`iterable-dns-entries-${targetDomain}.csv`}
          >
            <PrimaryButton data-test="csvDownload">
              <Export24 />
              Export table to CSV
            </PrimaryButton>
          </CSVLink>
        }
      >
        {isLoading ? 'DNS Setup' : `DNS Setup for ${targetDomain}`}
      </PageHeader>
      <p>
        Add the following entries to your DNS to enable authenticated sending & whitelabelled link
        rewriting.
      </p>
      {isLoading ? (
        <Skeleton height={250} />
      ) : (
        <Table>
          <TableHeader columns={COLUMNS} />
          <TableRows rows={entries} columns={COLUMNS} idKey="recordName" />
        </Table>
      )}
    </>
  );
};

export default withRouter(DnsSetup);
